export default {
    restricted_water_source: {
        name: "Restricted Water Source",
        url: "nwcg_water/restricted_water_source",
    },
    water_source: {
        name: "Water Source",
        url: "nwcg_water/water_source",
    },
    dip_site: {
        name: "Dip Site",
        url: "nwcg_water/dip_site",
    },
    hydrant: {
        name: "Hydrant",
        url: "nwcg_water/hydrant",
    },
    draft_site: {
        name: "Draft Site",
        url: "nwcg_water/draft_site",
    },
}
